import { getMonthName } from "common/helpers/utils";

export function formatMonthAndYear(data: { month: number; year: number }) {
  const { month, year } = data;
  const monthName = getMonthName(month - 1);
  if (monthName) {
    return `${monthName} ${year}`;
  }
  return year.toString();
}
export function formatRange(from: string, to: string) {
  return [from, to].filter((value) => !!value).join(" - ");
}
